<template lang='pug' src='./footer.pug'> </template>

<script>
  import Icon from 'components/icon/icon'
  import ContactForm from 'components/form/form-contact-us/form-contact-us'
  import AppointmentForm from 'components/form/form-request-appointment/form-request-appointment'

  export default {
    name: 'themeoptions',
    computed: {
      props () {
        return this.$store.state.app['themeoptions']
      }
    },
    components: {
      Icon,
      ContactForm,
      AppointmentForm
    },
    data () {
      return {
        modalShow: true
      }
    }
  }
</script>



// WEBPACK FOOTER //
// footer.vue?0d47fb08